<template>
  <!-- Kept for old links; redirects to the unified training result page -->
  <v-app>
    <v-main>
      <v-container fill-height>
        <v-row align="center" justify="center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'TrainingFailed',
  created() {
    this.$router.replace(`/prolific/study/${this.$route.params.sessionId}/training-result`);
  },
};
</script>
